import React from 'react';
import {ReactComponent as MedallionColor} from "../Medallion_color.svg";

export function LogoDisplay() {
    return (
        <MedallionColor className={"rounded-circle"} width={250} height={250}/>
    );

}
